import "./src/styles/css/normalize.css";
import "./src/styles/global.css";
import React from "react";
import Layout from "./src/components/parts/Layout";

export const wrapPageElement = ({ element, props }) => {
  return <Layout { ...props }>{ element }</Layout>;
};

export const onRouteUpdate = () => {
  navigator.serviceWorker.register("/vacancies/sw.js").then((reg) => {
    reg.update();
  });
};

export const onServiceWorkerUpdateReady = () => {
  window.location.reload(true);
};

// in gastby-browser.js
// export const shouldUpdateScroll = ({
//   routerProps: { location },
//   getSavedScrollPosition,
// }) => {
//   const currentPosition = getSavedScrollPosition(location);
//   const queriedPosition = getSavedScrollPosition({ pathname: `/random` });
//   window.scrollTo(...(currentPosition || [ 0, 0 ]));
//   if (location.pathname === "/vacancies") {
//     console.log(getSavedScrollPosition({ pathname: `/vacancies` }));
//     window.scrollTo(...(getSavedScrollPosition({ pathname: `/vacancies` }) || [ 0, 0 ]));
//     return false;
//   }
//   return false;
// };